import { render, staticRenderFns } from "./WarehousePurchaseItemDialog.vue?vue&type=template&id=1c54e772"
import script from "./WarehousePurchaseItemDialog.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports